document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-download-btn]").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior

            const imageUrl = this.getAttribute("data-image-url"); // Get image URL

            if (!imageUrl) {
                console.error("No image URL found.");
                return;
            }

            fetch(imageUrl)
                .then(response => response.blob()) // Convert to blob
                .then(blob => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = imageUrl.split("/").pop(); // Use original filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(error => console.error("Error downloading image:", error));
        });
    });
});
